export default "/images/pa_policy_sm.jpg?cb0f2659648961738b0dbd9f3829e619";